// extracted by mini-css-extract-plugin
export var borderRadius = "_63-4";
export var large = "_63-3";
export var logoContainer = "_63-0";
export var nameLogo = "_63-2";
export var small = "_63-1";